<template>
  <div>
    <div class="bg mb20">
      <el-radio-group v-model="searchCondition.settleState" size="small" @change="changeStatus">
        <el-radio-button :label="v.value" v-for="(v,i) in statusList" :key="i">{{v.label}}</el-radio-button>
      </el-radio-group>
    </div>
    <hm-content>
      <div class="flex item-center flex-end">
        <el-date-picker
            v-model="searchCondition.queryTime"
            clearable
            class="mr10"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
        <el-select v-model="searchCondition.serviceCode" filterable clearable size="small" class="mr10" placeholder="请选择代理商">
          <el-option
              v-for="(item,i) in agentList"
              :key="i"
              :label="item.storeName"
              :value="item.serviceCode">
          </el-option>
        </el-select>
       <!-- <el-input
            placeholder="请输入代理商"
            v-model="searchCondition.serviceName"
            size="small"
            class="mr20"
            clearable>
        </el-input>-->
        <el-input
            placeholder="请输入账单编号"
            v-model="searchCondition.settleSn"
            size="small"
            class="mr20"
            clearable>
        </el-input>
        <el-button type="primary" size="small" @click="queryList"
        >查询</el-button
        >
        <el-button type="primary" size="small" class="ml10" v-if="searchCondition.status == '待审批账单'"
        >下载结算报表</el-button
        >
      </div>
      <div class="mt20">
        <el-table
            :data="list"
            border
            stripe
            size="small"
            style="width: 100%">
          <el-table-column
              prop="serviceName"
              label="结算对象(代理商)"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="settleSn"
              label="账单编号"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="settleTime"
              label="账单生成时间"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="settleMonth"
              label="结算周期"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              prop="settleAmount"
              label="代理商分润"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              <span style="color: #FF0000;">
                ¥{{scope.row.settleAmount}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="settleState"
              label="结算状态"
              header-align="center"
              align="center"
              v-if="searchCondition.settleState == 'all'"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.settleState == 'hang'" style="color: #FF7F10">{{ getSettleStateVal(scope.row.settleState) }}</span>
              <span v-if="scope.row.settleState == 'wait'" style="color: #0081E5">{{ getSettleStateVal(scope.row.settleState) }}</span>
              <span v-if="scope.row.settleState != 'wait' && scope.row.settleState != 'hang'">{{ getSettleStateVal(scope.row.settleState) }}</span>
            </template>
          </el-table-column>
          <!--<el-table-column
              prop="num"
              label="挂起原因"
              header-align="center"
              align="center"
              v-if="searchCondition.settleState == 'all' || scope.row.settleState == 'hang'"
          >
            <template slot-scope="scope">
              <span style="color: #FF7F10;">
                {{scope.row.remark}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="czr"
              label="操作人"
              header-align="center"
              align="center"
              v-if="searchCondition.settleState != '待审批账单'"
          >
          </el-table-column>-->
          <el-table-column
              label="操作"
              header-align="center"
              align="center"
              width="240"
          >
            <template slot-scope="scope">
              <el-button type="text" style="color: #0081E5" size="small" v-if="scope.row.settleState == 'hang'" @click="toContinue(scope.row)"
              >继续审批</el-button
              >
              <el-button type="text" style="color: #0081E5" size="small" v-if="scope.row.settleState == 'wait' || scope.row.settleState == 'settleWait'" @click="toAudit(scope.row)"
              >结算审批</el-button
              >
              <el-button type="text" style="color: #0081E5" size="small" v-if="searchCondition.settleState != 'wait' && searchCondition.settleState != 'settleWait'" @click="toCat(scope.row)"
              >查看账单明细</el-button
              >
              <el-button type="text" style="color: #0081E5" size="small"  @click="toLog(scope.row)"
              >操作日志</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
    </hm-content>
    <!--审核弹框-->
    <div v-if="auditeOrgDialog">
      <el-dialog :visible.sync="auditeOrgDialog" :title="title" width="90%">
        <RedPackageSettlement :id="row.settleSn" @closeDialog="closeDialog" :settlementTime="row.settleMonth" :sendAgent="row.serviceName"></RedPackageSettlement>
      </el-dialog>
    </div>
    <!--操作日志弹框-->
    <el-dialog :visible.sync="logDialog" :title="title" width="600px">
      <el-table
          :data="logTable"
          border
          class="mt20"
          stripe
          size="small"
          style="width: 100%">
        <el-table-column
            prop="name"
            label="操作"
            header-align="center"
            align="center"
        >
          <template slot-scope="scope">
            {{ getLostSettleStateVal(scope.row.operState) }}
          </template>
        </el-table-column>
        <el-table-column
            prop="oper"
            label="操作者"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="操作时间"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            prop="remark"
            label="备注"
            header-align="center"
            align="center"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="logTotal"
            @current-change="logPaging"
            @size-change="logHandleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="logCurrentPage"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" @click="logDialog = false">
          关闭</el-button
        >
      </div>
    </el-dialog>
    <!--明细弹框-->
    <div v-if="catDialog">
      <el-dialog :visible.sync="catDialog" :title="title" width="90%">
        <RedPackageSettlement :showAudit="false" @closeDialog="closeDialog" :settlementTime="row.settleMonth" :sendAgent="row.serviceName" :id="row.settleSn"></RedPackageSettlement>
      </el-dialog>
    </div>
    <!--打款弹框-->
    <div v-if="daKuanDialog">
      <el-dialog :visible.sync="daKuanDialog" :title="title" width="90%">
        <RedPackageSettlement :showAudit="false" @closeDialog="closeDialog" :totalMoney="row.settleAmount" :settlementTime="row.settleMonth" :sendAgent="row.serviceName" :id="row.settleSn" :showDaKuan="true"></RedPackageSettlement>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import RedPackageSettlement from "@/components/RedPackageSettlement";
export default {
  components: {RedPackageSettlement},
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        settleState: "all",
        settleSn: "",
        serviceCode: ""
      },
      statusList: [
        {
          label: "全部",
          showNum: false,
          num: 0,
          value: "all"
        },
        {
          label: "待审批账单",
          showNum: true,
          num: 0,
          value: "wait"
        },
        {
          label: "待打款账单",
          showNum: true,
          num: 0,
          value: "settleWait"
        },
        {
          label: "已结算账单",
          showNum: false,
          num: 0,
          value: "settle"
        },
        {
          label: "待客户审批",
          showNum: false,
          num: 0,
          value: "confirmWait"
        },
        {
          label: "挂起",
          showNum: false,
          num: 0,
          value: "hang"
        }
      ],
      agentList: [],
      auditeOrgDialog: false,
      title: "",
      rules: {},
      logDialog: false,
      logTable: [],
      logTotal: 0,
      logCurrentPage: 1,
      logPageSize: 10,
      daKuanDialog: false,
      catDialog: false,
      row: {}
    };
  },
  created() {
    this.queryList();
    this.queryAgentList();
  },
  mounted() {},
  methods: {
    async queryAgentList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
      }
      const { result } = await this.$store.dispatch("querySettleAgentList", params);
      console.log(JSON.stringify( result.records))
      this.agentList = result.records;
    },
    closeDialog() {
      this.auditeOrgDialog = false;
      this.catDialog = false;
      this.daKuanDialog = false;
      this.queryList();
    },
    getLostSettleStateVal(state) {
      let val = "";
      switch (state) {
        case "wait":
          val = "账单待审批";
          break;
        case "confirmWait":
          val = "账单审批通过";
          break;
        case "settleWait":
          val = "客户已确认账单";
          break;
        case "settle":
          val = "打款至商户余额";
          break;
        case "hang":
          val = "操作挂起账单";
          break;
      }
      return val;
    },
    getSettleStateVal(state) {
      let val = "";
      switch (state) {
        case "wait":
          val = "待审批";
          break;
        case "confirmWait":
          val = "待客户审批";
          break;
        case "settleWait":
          val = "待打款账单";
          break;
        case "settle":
          val = "已结算";
          break;
        case "hang":
          val = "挂起";
          break;
      }
      return val;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    //继续审批
    toContinue(row) {
      this.row = row;
      this.$confirm("是否重新审批该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          settleSn: this.row.settleSn,
          settleState: "wait",
        }
       this.$store.dispatch("settleAudit", params).then(res =>{
         if (res.code === "0") {
           this.$message({
             message: "操作成功",
             type: "success"
           });
           this.queryList();
         }
       })

      }).catch(() => {});

      /*this.toAudit(row);*/
    },
    //查看明细
    toCat(row) {
      this.row = row;
      this.title = "查看明细";
      this.catDialog = true;
    },
    //操作日志
    toLog(row) {
      this.row = row;
      this.title = "操作日志";
      this.logCurrentPage = 1;
      //查询日志数据
      this.queryLogList();
      this.logDialog = true;
    },
    //结算审批
    toAudit(row) {
      this.row = row;
      console.log("row", this.row);
      if (row.settleState == 'settleWait') {
        this.title = "结算打款";
        this.daKuanDialog = true;
      } else {
        this.title = "结算审批";
        this.auditeOrgDialog = true;
      }
    },
    //状态改变
    changeStatus(val) {
      console.log("val",val);
      this.queryList();
    },
    async queryLogList() {
      let params = {
        pageSize: this.logPageSize,
        pageNo: this.logCurrentPage,
        settleSn: this.row.settleSn
      };
      const { code, result } = await this.$store.dispatch("querySettleLogList", params);
      if (code === "0") {
        const { total, records } = result;
        this.logTable = records;
        this.logTotal = total;
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0
          ? searchCondition.queryTime[0]
          : "";

      searchCondition.queryEndTime = this.isArray(searchCondition.queryTime) && searchCondition.queryTime.length > 0
          ? searchCondition.queryTime[1]
          : "";

      if (searchCondition.settleState == "all") {
        searchCondition.settleState = "";
      }

      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryAgentSettlementList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    logPaging(page) {
      this.logCurrentPage = page;
      this.queryLogList();
    },
    logHandleSizeChange(size) {
      this.logCurrentPage = 1;
      this.logPageSize = size;
      this.queryLogList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
  /deep/ .el-radio-button--small .el-radio-button__inner {
    width: 150px !important;
  }
}
</style>
